module.exports = __webpack_public_path__ + "static/media/service3.4eb2ffb9.png";